<template>
  <div>
  <v-app-bar app color="red darken-2" dark :clipped-left="clipped" >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
          <v-icon v-if="!drawer">menu</v-icon>
          <v-icon v-if="drawer">mdi-arrow-left</v-icon>
        </v-app-bar-nav-icon>

        <v-progress-linear indeterminate color="white" v-if="this.searching()"></v-progress-linear>


        <v-layout v-if="this.etablissement==null&&!this.searching()">
          <v-toolbar-title>Fiche entreprise</v-toolbar-title>
        </v-layout>
        <EtabToolbar v-bind:etablissement="etablissement" id="print_bar"
                     v-if="this.etablissement!=null&&!this.searching()"></EtabToolbar>
        <v-spacer/>

        <v-btn icon @click="scrollMeTo('home')">
          <v-icon>mdi-arrow-up</v-icon>

        </v-btn>

        <router-link to="/home" tag="button"> <v-icon>mdi-home</v-icon></router-link>

     <v-btn icon>
          <v-icon @click="print()">mdi-printer</v-icon>
        </v-btn>
        <span>{{ username }}</span>
        <v-btn icon>
          <v-icon @click="logout()">mdi-logout-variant</v-icon>
        </v-btn>


      </v-app-bar>

      <v-main>

        <v-row v-if="this.$store.state.error">
          <v-col cols="12">
            <v-alert
                v-if="this.$store.state.error"
                v-model="this.$store.state.error"
                border="left"
                close-text="Close Alert"
                dark
                type="error"
                @click="removeErrors"
                dismissible
            >
              {{ this.$store.state.error.response.data.reason }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <Etablissement v-bind:siret="siret" id="print"/>
        </v-row>

      </v-main>
</div>
</template>

<script>
import Etablissement from "@/components/etablissement/Etablissement";
import EtabToolbar from "@/components/etablissement/EtabToolbar";
import Mgr from "@/services/SsoService";

export default {
  name: "Etab",
   components: {
     Etablissement, EtabToolbar
  },
   beforeMount: function () {
    // récupération des parametres de la route
    if ("siret" in this.$route.params) {
      this.siret = this.$route.params.siret
    }
    if ("search" in this.$route.params) {
      this.search = this.$route.params.search
      //console.log("param search"+this.search)
    }
  },
  data: () => ({
    drawer: true,
    clipped: false,
    siret: "",
    search: "",
    searchString: "",
    api_url: '',
    env: null,
    health: {},
    loading_health: true,
    health_error: null,
    request_status: '000',

  }),
   computed: {
     username: function () {
       return this.$store.getters.userInfo;
     },
   },
  methods: {
    print() {
      // Get HTML to print from element
        const prtHtmlHead = document.getElementById('print_bar').innerHTML;

        const prtHtml = document.getElementById('print').innerHTML;

        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }

        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0');

        WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtmlHead}
            ${prtHtml}
          </body>
        </html>`);
        WinPrint.document.close();
        window.setTimeout(() => {WinPrint.focus(); WinPrint.print()}, 900)

       // WinPrint.focus();
       // WinPrint.print();
       // WinPrint.close();
    },
    removeErrors() {
      this.$store.commit("setError", "")
    },
    onDisplayEtablissement(siret) {
      // event when clic on an Entreprise to view it's data
      this.siret = siret

    },
    etablissement() {
      return this.$store.getters.etablissemement()
    },
    logout() {
      var user = new Mgr();
      user.signOut();
    },
    searching() {
      return this.$store.state.searchingEtab
    },
    home() {
      return this.$store.getters.home
    }

  },
}
</script>

<style scoped>

</style>
